import { SunIcon } from "@heroicons/react/24/outline";
import Icon from "components/Icon/Icon";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { Weather } from "types/Weather";

function degreesToDirection(degrees: number): string {
  if (Number.isNaN(degrees)) return "";

  const directions = [
    "N",
    "NNE",
    "NE",
    "ENE",
    "E",
    "ESE",
    "SE",
    "SSE",
    "S",
    "SSO",
    "SO",
    "OSO",
    "O",
    "ONO",
    "NO",
    "NNO",
  ];

  const normalized = ((degrees % 360) + 360) % 360;

  const index = Math.round(normalized / 22.5) % 16;

  return directions[index];
}

type Props = {
  items?: Weather[] | null;
  loading?: boolean;
};
function WeatherInfo(props: Props) {
  const { items, loading } = props;
  const { t } = useTranslation();

  return (
    <div className="flex flex-row gap-2  ">
      {loading ? (
        <div>{t("common.loading")}</div>
      ) : items?.length ? (
        items.map((weather, i) => {
          const isLast = i === items.length - 1;
          return (
            <div
              className={`flex flex-col gap-2 items-center shrink-0 ${
                !isLast && "border-r border-zinc-100 pr-2"
              }`}
            >
              <p className="font-bold">{dayjs(weather.date).format("H:mm")}</p>
              <p>{`${weather.temperature} °C`}</p>
              <div className="flex flex-row gap-2 items-center">
                <Icon
                  style={{
                    transform: `rotate(${
                      (weather.windDirection + 180) % 360
                    }deg)`,
                  }}
                  className="h-6"
                  name="ArrowLongUpIcon"
                />
                {degreesToDirection(weather.windDirection)}
              </div>
              <p className="font-bold text-md shrink-0">
                {`${Math.round(weather.windSpeed * 3.6)} `}
                <span className="text-xs">km/h</span>
              </p>
              <p className="text-blue-700">{`${weather.precipitation} mm`}</p>
            </div>
          );
        })
      ) : (
        <div>
          <p className="text-sm text-zinc-500 italic flex flex-row gap-2 bg-zinc-50 rounded-xl p-2">
            <SunIcon className="h-4" />

            {t("common.noWeather")}
          </p>
        </div>
      )}
    </div>
  );
}

export default WeatherInfo;
